// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"861df91d","304":"f4a2226b","453":"f9db1f37","501":"bb72798a"}[chunkId] + ".chunk.js";
};